<template>
  <div class="base-response-component">
    <!-- Error State -->
    <div v-if="response.status === 'error'" class="response-error">
      <div class="error-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="15" y1="9" x2="9" y2="15"></line>
          <line x1="9" y1="9" x2="15" y2="15"></line>
        </svg>
      </div>
      <span class="error-message">{{ response.message || 'An error occurred' }}</span>
    </div>

    <!-- Success State -->
    <div v-else-if="response.status === 'success'" class="response-content">
      <slot :response="response"></slot>
    </div>

    <!-- Unknown Status -->
    <div v-else class="response-unknown">
      <div class="warning-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="m21.73 18-8-14a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
          <line x1="12" y1="9" x2="12" y2="13"></line>
          <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>
      </div>
      <span>Received unexpected response</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseResponseComponent',
  props: {
    response: {
      type: Object,
      required: true,
      validator(value) {
        return value && typeof value === 'object';
      }
    }
  }
};
</script>

<style scoped>
.base-response-component {
  width: 100%;
}

.response-error,
.response-unknown {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 0.9rem;
}

.response-error {
  background-color: #fef2f2;
  color: #dc2626;
  border: 1px solid #fecaca;
}

.response-unknown {
  background-color: #fffbeb;
  color: #d97706;
  border: 1px solid #fed7aa;
}

.error-icon,
.warning-icon {
  margin-right: 8px;
  display: flex;
  align-items: center;
}

.response-content {
  width: 100%;
}

.error-message {
  font-weight: 500;
}
</style>